import platform from "Pub/js/platform";
const { NCSelect } = platform.base;
const NCOption = NCSelect.NCOption;

export default function ItemSelect(props) {
    const renderOptions = () => {
        return props.optionData.map((item) => (
            <NCOption value={item.value}>{item.display}</NCOption>
           
        ));
    };

    return (
        <NCSelect 
            value={props.value}
            style={{ width: 250}}
            showSearch
            supportSearch //加这个参数才能输入搜索
            optionFilterProp="children"
            onChange={props.onChange}
        >
            {renderOptions()}
        </NCSelect>
    );
}